require('../css/style_materia.styl');
require('@glidejs/glide/dist/css/glide.core.min.css');
require('@glidejs/glide/dist/css/glide.theme.min.css');

// require('./lazyload.js');
// require('./modal.js');
// require('./custom.js');
// require("./offcanvas.js");
// require("./requests.js");
require("./gallery.js");
// require("./page-contato.js");
// require("./infiniteScrollEditoria.js");
// require("./infiniteScrollHome.js");
// require("./infiniteScrollBuscaAvancada.js");
// require("./headerAlt");
// require('./specialContent');
// require('./busca-avancada');
require('./keep-reading');
// require('./listar_mais_busca.js');
// require('./listar_mais_editorias.js');
require("./analytics.js");

require('./../img/no-image.png');
function requireAll(r) {
    r.keys().forEach(r);
}
requireAll(require.context('../svg', true, /\.svg$/));


// Init

    // require('./assetdocument.addEventListener("DOMContentLoaded", () => {
    //     console.log('Ready project!');s/svg/sprite.svg');
// });
